// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2Foqh","box":"WorkspacesBox_box__1uw-3","node":"WorkspacesBox_node__Q65dV"};